// Email service using server-side Resend API
const API_ENDPOINT = '/api/send-email';

// Send booking notification to business
export const sendBookingEmail = async (bookingData) => {
  try {
    console.log('Sending business email via API...');

    const response = await fetch(API_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        bookingData,
        emailType: 'business'
      })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Failed to send email');
    }

    console.log('Business email sent successfully');
    return { success: true, response: data };
  } catch (error) {
    console.error('Failed to send business email:', error);
    return { success: false, error };
  }
};

// Send confirmation email to customer
export const sendCustomerConfirmationEmail = async (bookingData) => {
  try {
    console.log('Sending customer confirmation email to:', bookingData.email);

    const response = await fetch(API_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        bookingData,
        emailType: 'customer'
      })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Failed to send email');
    }

    console.log('Customer confirmation email sent successfully');
    return { success: true, response: data };
  } catch (error) {
    console.error('Failed to send customer confirmation email:', error);
    return { success: false, error };
  }
};

// Send both emails at once (more efficient)
export const sendAllBookingEmails = async (bookingData) => {
  try {
    console.log('Sending all booking emails...');

    const response = await fetch(API_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        bookingData,
        emailType: 'both'
      })
    });

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.error || 'Failed to send emails');
    }

    console.log('All booking emails sent successfully');
    return { success: true, response: data };
  } catch (error) {
    console.error('Failed to send booking emails:', error);
    return { success: false, error };
  }
};
